// src/view/com/TickerSelector.js
import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, } from '@mui/material';
//import { styled } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { etfTickersAtom, stockTickersAtom } from '../../value/AppModel';


const ETF_TICKER_JSON_URL = '/costav/ticker/krx_etf_ticker.json';
const KSTOCK_TICKER_JSON_URL = '/costav/ticker/kstock_ticker.json';

/*
ticker json data structure
{
    "msg":"ok",
    "data":[
        {"code":"466400","name":"1Q 25-08 회사채(A+이상)액티브","market":"KRX"},
        {"code":"491610","name":"1Q CD금리액티브(합성)","market":"KRX"},
        {"code":"451060","name":"1Q K200액티브","market":"KRX"}
    ]
}
*/

export default function TickerSelector({
    open,
    type, // 'etf', 'stock'
    onClose, // (ticker) => void. if ticker is null, just close this.
}) {
    const [stockTickers, setStockTickers] = useAtom(stockTickersAtom); // fetch from KSTOCK_TICKER_JSON_URL
    const [etfTickers, setEtfTickers] = useAtom(etfTickersAtom); // fetch from ETF_TICKER_JSON_URL
    const [search, setSearch] = useState('');
    const [tickers, setTickers] = useState([]);

    useEffect(() => {
        if (open) {
            if (type === 'etf') {
                if(etfTickers.length === 0) {
                    // fetch from ETF_TICKER_JSON_URL
                    fetch(ETF_TICKER_JSON_URL)
                        .then(response => response.json())
                        .then(data => {
                            setEtfTickers(data.data);
                            setTickers(data.data);
                        })
                        .catch(error => {
                            console.error('Error fetching ETF tickers:', error);
                            alert("ETF 종목코드 데이터를 가져오는 중 오류가 발생했습니다. 코드를 직접 입력하세요.");
                        });
                }
                else {
                    setTickers(etfTickers);
                }
            }
            else {
                if(stockTickers.length === 0) {
                    fetch(KSTOCK_TICKER_JSON_URL)
                        .then(response => response.json())
                        .then(data => {
                            setStockTickers(data.data);
                            setTickers(data.data);
                        })
                        .catch(error => {
                            console.error('Error fetching stock tickers:', error);
                            alert("주식 종목코드 데이터를 가져오는 중 오류가 발생했습니다. 코드를 직접 입력하세요.");
                        });
                }
                else {
                    setTickers(stockTickers);
                }
            }
        }
    }, [open, type, stockTickers, etfTickers, setStockTickers, setEtfTickers]);

    useEffect(() => {
        const srcTickers = type === 'etf' ? etfTickers : stockTickers;
        if(search) {
            const filtered = srcTickers.filter(ticker => {
                return ticker.name.includes(search.toUpperCase()) || ticker.code.includes(search.toUpperCase());
            });
            setTickers(filtered);
        }
        else {
            setTickers(srcTickers);
        }
    }, [search, stockTickers, etfTickers, type])

    return(
        <Box p={2}>
            <TextField
                onChange={(e) => setSearch(e.target.value)}
                value={search}
                label={type === 'etf' ? "ETF 검색" : "종목 검색"}
            />
            <Box style={{marginTop:5, maxHeight:400, overflow:'auto'}}>
                {
                    tickers.map(ticker => (
                        <div key={ticker.code}>
                        <Button
                            onClick={() => {
                                onClose(`${ticker.market}:${ticker.code}`);
                            }}
                        >
                            {ticker.name} ({ticker.market}:{ticker.code})
                        </Button>
                        </div>
                    ))
                }
            </Box>
        </Box>
    );
}